//customSvgs.ts
import { h } from "vue";
import type { IconSet, IconProps } from "vuetify"
import TheLeegIcon from './TheLeegIcon.vue'

const customSvgNameToComponent: any = {
  TheLeegIcon,
}

const customSVGs: IconSet = {
  component: (props: IconProps) => h(customSvgNameToComponent[props.icon]),
};

export { customSVGs /* aliases */ };